import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { catchError, EMPTY, map, Observable, tap } from 'rxjs';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { MobileApiService } from 'src/app/core/services/mobile-api';
import { RoutingPathsEnum, RoutingService } from 'src/app/core/services/routing/routing.service';
import { TagDataService } from 'src/app/core/services/tag-data/tag-data.service';
import { ICoApplicantDecryptDataResponse } from './co-app-details.model';

@Injectable({
	providedIn: 'root'
})
export class CoAppApplyResolver implements Resolve<ICoApplicantDecryptDataResponse> {
	constructor(
		private mobileAppService: MobileApiService,
		private authService: AuthenticationService,
		private routingService: RoutingService,
		private tagDataService: TagDataService
	) {}

	resolve(route: ActivatedRouteSnapshot): Observable<ICoApplicantDecryptDataResponse> {
		const token = route.params?.token;
		this.tagDataService.link(
			{},
			{
				event_category: 'co_applicant_landing_page_resolver',
				tealium_event: `Co Applicant Landing Page Resolver`,
				event: 'Co Applicant Landing Page Resolver'
			}
		);
		this.authService.updateAuthorizationToken(`SJWT ${token}`);
		return this.mobileAppService.verifyCoApplicantDetails(token).pipe(
			tap((response) => {
				this.authService.updateAuthorizationToken(response.data.token);
			}),
			map((response) => response.data),
			catchError((error) => {
				this.tagDataService.link(
					{},
					{
						event_category: 'co_applicant_landing_error',
						tealium_event: `Co Applicant Landing Error`
					}
				);
				this.routingService.route(RoutingPathsEnum.home);
				return EMPTY;
			})
		);
	}
}
